const PHONE_VLD = /^[+]?\d+$/;

// this is simple email validation
// it will counter id with multiple @
const EMAIL_VLD = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const UserIdenityType = {
  PHONE_NUMBER: 'phone-number',
  EMAIL: 'email',
  USERNAME: 'username',
};

export const getUserIdenityType = (id: any) => {
  // check if phone number
  if (PHONE_VLD.test(id)) {
    return UserIdenityType.PHONE_NUMBER;
  }
  if (EMAIL_VLD.test(id)) {
    // return email type
    return UserIdenityType.EMAIL;
  }
  // otherwise return username type
  return UserIdenityType.USERNAME;
};

export const isIdnTimesEmail = (email: string) => {
  const idnTimesRegex = /@idntimes\.com$/;

  return idnTimesRegex.test(email);
};

export const maskPhoneNumber = (phone: string, symbol?: string) => {
  let maskPhone = phone;
  if (phone.length > 2) {
    maskPhone = '';
    for (let i = 0; i < phone.length - 3; i++) {
      maskPhone += symbol || '*';
    }
    maskPhone += phone.substr(phone.length - 3);
  }
  return maskPhone;
};

export const maskEmail = (email: any) => {
  // split email name from its domain
  const [emailName, emailDomain] = email.split('@');
  let enEmail = emailName;
  if (emailName.length > 2) {
    [enEmail] = emailName;
    for (let i = 0; i < emailName.length - 2; i++) {
      enEmail += '*';
    }
    enEmail += emailName[emailName.length - 1];
  }
  enEmail += `@${emailDomain}`;
  return enEmail;
};

export const maskUserIdentity = (id: any, isMask: boolean) => {
  if (!isMask) {
    return id;
  }

  if (getUserIdenityType(id) === UserIdenityType.PHONE_NUMBER) {
    return maskPhoneNumber(id);
  }
  return maskEmail(id);
};

export const getFirstName = (fullName?: string) => {
  return fullName?.split(' ')[0] ?? '';
};

export const getLastName = (fullName?: string) => {
  const names = fullName?.split(' ');
  if (names) {
    return names[names.length - 1];
  }
  return '';
};
